<template>
  <div>
    <v-net-footprint
      v-if="$laravel.user.is_subscribed"
      :achievements="achievements"
    />

    <v-subscribe-action v-if="!$laravel.user.is_subscribed && $laravel.user.company_id == null" />

    <v-offset
      v-if="$laravel.user.company_id != null"
      :achievements="achievements"
    />

    <v-planted-trees :achievements="achievements" />
  </div>
</template>
<script>
import netFootprint from "./achievements/net-footprint.vue";
import subscribeAction from "./subscribe-action.vue";
import offset from "./achievements/offset.vue";
import plantedTrees from "./achievements/planted-trees.vue";
export default {
  name: "v-achievements-details",
  components: {
    "v-net-footprint": netFootprint,
    "v-subscribe-action": subscribeAction,
    "v-offset": offset,
    "v-planted-trees": plantedTrees
  },
  props: {
    achievements: {
      type: Object,
      required: true
    }
  }
};
</script>
